import React from "react";
import './Footer.scss'
import {useSelector} from "react-redux";
const Footer = ()=>{
 const show = useSelector(state=> state?.profileReducer?.bottomHolder)
    return(
        <div className={!show ? 'footerContainer' : 'secFooterContainer'}>
            <div className={'hold'}>US</div>
            <div className={'bottom'}><span>&copy;</span>2022 Qisen Wang. All Rights Reserved | Powered by: React</div>
        </div>
    )

}



export default Footer
